import { F0Select } from '@factorialco/f0-react'
import { FinanceEnumsQuoteTypeEnum } from 'generated/resources/graphql'

import { useMemo } from 'modules/core/hooks/useMemo'

import { quoteTranslateType } from 'modules/finance/components/Quotes/utils'

interface QuoteTypeSelectorProps {
  value?: FinanceEnumsQuoteTypeEnum
  onChange: (value: FinanceEnumsQuoteTypeEnum) => void
  label?: string
  error?: string
  disabled?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export const QuoteTypeSelector = ({
  value,
  onChange,
  label,
  error,
  disabled,
  size = 'md',
}: QuoteTypeSelectorProps) => {
  const buildOptions = useMemo(() => {
    const quoteTypeOptions: FinanceEnumsQuoteTypeEnum[] = ['products', 'timeandmaterials']

    return quoteTypeOptions.map((quoteType) => ({
      label: quoteTranslateType(quoteType),
      value: quoteType,
    }))
  }, [])

  return (
    <F0Select
      size={size}
      label={label}
      options={buildOptions}
      value={value ?? undefined}
      onChange={(newValue: FinanceEnumsQuoteTypeEnum) => {
        if (newValue) {
          onChange(newValue)
        }
      }}
      error={error}
      disabled={disabled}
    />
  )
}
